import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Drawer,
    useMediaQuery,
    Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import "./Recommendations.css";
import PageTitle from "../../components/PageTitle/PageTitle";
import customHttp from "../../services/customHTTP";
import ProductCard from "../../components/ProductCard/ProductCard";
import Divider from "@mui/material/Divider";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup, { toggleButtonGroupClasses } from "@mui/material/ToggleButtonGroup";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import ListIcon from "@mui/icons-material/List";
import ProductList from "../../components/ProductList/ProductList";
import MenuIcon from "@mui/icons-material/Menu";
import ContextFilterAndSort from "../../components/ContextFilterAndSort/ContextFilterAndSort";
import { useSite } from "../../context/siteContext";
import { useAuth } from "../../context/authContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import NotifyPurchaser from "../../components/NotifyPurchaser/NotifyPurchaser";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
	[`& .${toggleButtonGroupClasses.grouped}`]: {
		margin: theme.spacing(0.5),
		marginRight: -1,
		border: 0,
		borderRadius: theme.shape.borderRadius,
		[`&.${toggleButtonGroupClasses.disabled}`]: {
			border: 0,
		},
	},
	[`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
		marginLeft: -1,
		borderLeft: "1px solid transparent",
	},
}));

function Recommendations() {
	const [items, setItems] = useState([]);
	const [selectedItem, setSelectedItem] = useState(null);
	const [searchTerm, setSearchTerm] = useState("");
	const [listSearchTerm, setListSearchTerm] = useState("");
	const [open, setOpen] = useState(false);
	const [newListName, setNewListName] = useState("");
	const [newListDescription, setNewListDescription] = useState("");
	const [products, setProducts] = useState([]);
	const [type, setType] = useState("card");
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [sortOption, setSortOption] = useState("");
	const [sortOptionProducts, setSortOptionProducts] = useState("");
	const isMobile = useMediaQuery("(max-width:600px)");
	const [error, setError] = useState("");
	const [isCreatingList, setIsCreatingList] = useState(false);
	const navigate = useNavigate();
	const { selectedSite, siteData } = useSite();
	const { user } = useAuth();
	const [allUsers, setAllUsers] = useState([]);

	const sortOptions = ["Name Asc", "Name Desc"];
	const sortOptionsProducts = ["Name Asc", "Name Desc", "Number Asc", "Number Desc", "Price Asc", "Price Desc"];

	const handleSortChange = (value) => {
		setSortOption(value);
		console.log(items);
		if (value === "Name Asc") {
			setItems((prevProducts) => [...prevProducts].sort((a, b) => a.name.localeCompare(b.name)));
		} else if (value === "Name Desc") {
			setItems((prevProducts) => [...prevProducts].sort((a, b) => b.name.localeCompare(a.name)));
		}
	};

	const handleSortChangeProducts = (value) => {
		setSortOptionProducts(value);

		if (value === "Name Asc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => a.product_name.trim().localeCompare(b.product_name.trim()))
			);
		} else if (value === "Name Desc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => b.product_name.trim().localeCompare(a.product_name.trim()))
			);
		} else if (value === "Number Asc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => a.product_name.trim().localeCompare(b.product_name.trim()))
			);
		} else if (value === "Number Desc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => b.product_name.trim().localeCompare(a.product_name.trim()))
			);
		} else if (value === "Price Asc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => a.product_sell_price - b.product_sell_price)
			);
		} else if (value === "Price Desc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => b.product_sell_price - a.product_sell_price)
			);
		}
	};

	const handleItemClick = async (item) => {
		try {
			const req_body = {
				list_id: item.id,
			};
			const response = await customHttp.post("/recommendations/products/list", req_body);
			if (response.status === 200) {
				const products = response.data.data;
				setProducts(products);
			} else if (response.status === 404) {
				console.error("No products found for the selected list.");
			} else {
				console.error("Error fetching products:", response.error);
			}
			setSelectedItem(item);
		} catch (error) {
			console.error("Error fetching products:", error);
		}
	};

	const handleType = (event, newAlignment) => {
		setType(newAlignment);
	};

	const handleRemoveProduct = async (productID, machineID) => {
		try {
			const req_body = {
				list_id: selectedItem.id,
				product_id: productID,
				machine_id: machineID,
			};

			const response = await customHttp.post("/recommendations/products/delete", req_body);
			if (response.status === 200) {
				const updatedProducts = products.filter((product) => product.product_id !== productID);
				setProducts(updatedProducts);

				Swal.fire({
					icon: "success",
					title: "Removed",
					text: "Part successfully removed from the list.",
				});
			} else {
				console.error("Failed to remove part:", response.data?.error || "Unknown error");
				Swal.fire({
					icon: "error",
					title: "Error",
					text: response.data?.error || "Failed to remove the part.",
				});
			}
		} catch (error) {
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "An error occurred while removing the part. Please try again.",
			});
		}
	};

	const fetchData = async (endpoint) => {
		try {
			const response = await customHttp.get(endpoint);
			if (response.data.data.length > 0) {
				console.log(response.data.data);
				return response.data.data
			} else {
				setError(`Failed to fetch data: No data found for ${endpoint}.`);
			}
		} catch (err) {
			setError(`Failed to fetch data from ${endpoint}: ${err.message}`);
		}
	};

	useEffect(() => {
		const fetchRecommendationsAndProducts = async () => {
			try {
				const all_users = await fetchData("/users");
				setAllUsers(all_users);
				const user_id = user.user_id;
				const site_id = siteData.filter((i) => i.customer_site_number === selectedSite)[0]?.site_id;

				if (!site_id) {
					console.error("Site ID not found");
					return;
				}

				// Fetch recommendations
				const recommendationsResponse = await customHttp.get(`/recommendations/${user_id}/${site_id}`);
				if (recommendationsResponse.status === 200) {
					const recommendations = recommendationsResponse.data.data;
					console.log("Recommendations: ", recommendations);
					setItems(recommendations);

					if (recommendations.length > 0) {
						const firstRecommendation = recommendations[0];
						setSelectedItem(firstRecommendation);

						// Fetch products for the first recommendation
						const req_body = { list_id: recommendationsResponse.data.data[0].id };
						const productsResponse = await customHttp.post("/recommendations/products/list", req_body);
						if (productsResponse.status === 200) {
							const randomProducts = productsResponse.data.data;
							console.log(`Products for ${recommendationsResponse.data.data[0].id}: `, randomProducts);
							setProducts(randomProducts);
						} else {
							console.error("Failed to fetch products:", productsResponse.error);
						}
					}
				} else {
					console.error("Failed to fetch recommendations:", recommendationsResponse.error);
				}
			} catch (error) {
				console.error("Error fetching recommendations or products:", error);
			}
		};

		if (selectedSite) fetchRecommendationsAndProducts();
	}, [selectedSite]);

	const handleDeleteItem = async (id) => {
		try {
			const confirmation = await Swal.fire({
				title: "Are you sure?",
				text: "This will delete this list permanently.",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#3085d6",
				confirmButtonText: "Yes, delete it!",
			});

			if (!confirmation.isConfirmed) return;
			const user_id = user.user_id;
			const site_id = siteData.filter((i) => i.customer_site_number === selectedSite)[0]?.site_id;

			if (!site_id) {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: "Failed to delete the list. Please try again",
				});
				return;
			}

			const response = await customHttp.delete(`/recommendations/${id}`, {
				data: { user_id, site_id },
			});

			if (response.status === 200) {
				setItems((prevItems) => prevItems.filter((item) => item.id !== id));

				if (selectedItem?.id === id) {
					setSelectedItem(items[0] || null);
				}
			} else {
				console.error("Failed to delete list:", response.error);
				Swal.fire({
					icon: "error",
					title: "Error",
					text: "Failed to delete the list. Please try again",
				});
			}
		} catch (error) {
			console.error("Error deleting list:", error);
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Failed to delete the list. Please try again",
			});
		}
	};

	useEffect(() => {
		console.log("Selected List: ", selectedItem)
	}, [selectedItem])

	const filteredItems = items.filter((item) => item?.name?.toLowerCase().includes(listSearchTerm.toLowerCase()));

	const handleSearchChange = (value) => {
		setSearchTerm(value);
	};

	const handleListSearchChange = (value) => {
		setListSearchTerm(value);
	};

	const onSaveForLater = (id) => {
		console.log(`Product ${id} added to Saved For Later`);
	};

	const handleOpenDialog = () => {
		setOpen(true);
	};

	const handleCloseDialog = () => {
		setOpen(false);
		setNewListName("");
		setNewListDescription("");
	};

	const handleCreateList = async () => {
		if (!newListName) {
			setError("List name is required!");
			return;
		}
		setIsCreatingList(true);
		try {
			const user_id = user.user_id;
			const site_id = siteData.filter((i) => i.customer_site_number === selectedSite)[0]?.site_id;

			if (!site_id) {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: "Failed to Create the list. Please try again",
				});
				return;
			}

			const newList = {
				name: newListName,
				description: newListDescription || "",
				user_id,
				site_id,
			};

			const listExists = items.some((item) => item.name === newListName);

			if (listExists) {
				setError("A list with this name already exists for this site.");
				return;
			}
			const response = await customHttp.post("/recommendations", newList);

			if (response.status === 200) {
				const updatedResponse = await customHttp.get(`/recommendations/${user_id}/${site_id}`);
				if (updatedResponse.status === 200) {
					setItems(updatedResponse.data.data);

					const newListItem = updatedResponse.data.data.find((item) => item.name === newListName);
					setSelectedItem(newListItem || null);
					setProducts([]);
				} else {
					console.error("Failed to refresh recommendations:", updatedResponse.error);
				}

				handleCloseDialog();
			} else {
				console.error("Failed to create list:", response.error);
				Swal.fire({
					icon: "error",
					title: "Error",
					text: "Failed to Create the list. Please try again",
				});
			}
		} catch (error) {
			console.error("Error creating list:", error);
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Failed to Create the list. Please try again",
			});
		} finally {
			setIsCreatingList(false);
		}
	};

	const toggleDrawer = () => {
		setDrawerOpen(!drawerOpen);
	};

	const handleAddProductsNaviagte = () => {
		navigate("/rspl");
	};

	return (
		<Box className="recommendation-page" sx={{ padding: isMobile ? "10px" : "40px" }}>
			<PageTitle title="My Lists" />

			<Box display="flex" justifyContent={isMobile ? "space-between" : "flex-end"} mb={2}>
				{isMobile && (
					<IconButton onClick={toggleDrawer}>
						<MenuIcon />
					</IconButton>
				)}

					<Button
						variant="contained"
						color="primary"
						sx={{ backgroundColor: "var(--primary-main)", ml: 2 }}
						onClick={handleOpenDialog}>
						Create List
					</Button>

			</Box>

			<Dialog open={open} onClose={handleCloseDialog}>
				<Box display="flex" justifyContent="flex-end" p={1}>
					<IconButton
						aria-label="close"
						onClick={handleCloseDialog}
						sx={{ position: "relative", top: 4, right: 4 }}>
						<CloseIcon />
					</IconButton>
				</Box>
				<DialogTitle sx={{ textAlign: "center", mt: -4, fontSize: "25px" }}>Create a New List</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						label="List Name"
						type="text"
						fullWidth
						required
						value={newListName}
						error={!!error}
						helperText={error}
						onChange={(e) => setNewListName(e.target.value)}
						sx={{ mb: 2 }}
					/>
					<TextField
						margin="dense"
						label="List Description"
						type="text"
						fullWidth
						multiline
						rows={4}
						value={newListDescription}
						onChange={(e) => setNewListDescription(e.target.value)}
					/>
				</DialogContent>
				<DialogActions sx={{ justifyContent: "center" }}>
					<Button
						onClick={handleCreateList}
						color="primary"
						variant="contained"
						disabled={isCreatingList}
						sx={{ backgroundColor: "var(--primary-main)", mb: 2 }}>
						Create List
					</Button>
				</DialogActions>
			</Dialog>

			<Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
				<Box width="250px" p={2}>
					<ContextFilterAndSort
						value={listSearchTerm}
						onSearchChange={handleListSearchChange}
						placeholder="Search list"
						options={sortOptions}
						selectedOption={sortOption}
						onSortChange={handleSortChange}
						showSort
						showSearch
					/>
					<List style={{ overflowY: "auto", maxHeight: "500px" }}>
						{filteredItems.length > 0 ? (
							filteredItems.map((item) => (
								<ListItem
									key={item.id}
									button
									onClick={() => handleItemClick(item)}
									style={{
										cursor: "pointer",
										backgroundColor: selectedItem?.id === item.id ? "#e8e8e8" : "transparent",
									}}
									sx={{
										"&:hover": {
											color: "var(--primary-main)",
											transition: "0.2s",
										},
									}}>
									<ListItemText
										primary={item.name}
										primaryTypographyProps={{
											style: {
												color: selectedItem?.id === item.id ? "var(--primary-main)" : "inherit",
												fontWeight: "bold",
											},
										}}
									/>
									<IconButton
										edge="end"
										aria-label="delete"
										onClick={(e) => {
											e.stopPropagation();
											handleDeleteItem(item.id);
										}}
										style={{
											color: selectedItem?.id === item.id ? "var(--primary-main)" : "inherit",
										}}>
										<DeleteIcon />
									</IconButton>
								</ListItem>
							))
						) : (
							<div
								style={{
									textAlign: "center",
									padding: "20px",
									color: "gray",
									fontStyle: "italic",
									fontSize: "16px",
									height: "100%",
								}}>
								No items to display
							</div>
						)}
					</List>
				</Box>
			</Drawer>

			<Box display="flex" height="100vw">
				{!isMobile && (
					<Box
						width={isMobile ? "100%" : "20%"}
						pr={2}
						style={{ padding: "8px", height: "100%", overflow: "auto" }}>
						<Box display="flex" justifyContent="center" alignItems="center">
							<ContextFilterAndSort
								value={listSearchTerm}
								onSearchChange={handleListSearchChange}
								placeholder="Search list"
								options={sortOptions}
								selectedOption={sortOption}
								onSortChange={handleSortChange}
								showSort
								showSearch
							/>
						</Box>
						<List style={{ overflowY: "auto", maxHeight: "500px" }}>
							{filteredItems.length > 0 ? (
								filteredItems.map((item) => (
									<ListItem
										key={item.id}
										button
										onClick={() => handleItemClick(item)}
										style={{
											cursor: "pointer",
											backgroundColor: selectedItem?.id === item.id ? "#e8e8e8" : "transparent",
										}}
										sx={{
											"&:hover": {
												color: "var(--primary-main)",
												transition: "0.2s",
											},
										}}>
										<ListItemText
											primary={item.name}
											primaryTypographyProps={{
												style: {
													color:
														selectedItem?.id === item.id
															? "var(--primary-main)"
															: "inherit",
													fontWeight: "bold",
												},
											}}
										/>
										{(item.user_id === user.user_id || user.user_role === "Admin") && (
											<IconButton
												edge="end"
												aria-label="delete"
												onClick={(e) => {
													e.stopPropagation();
													handleDeleteItem(item.id);
												}}
												style={{
													color:
														selectedItem?.id === item.id
															? "var(--primary-main)"
															: "inherit",
												}}>
												<DeleteIcon />
											</IconButton>
										)}
									</ListItem>
								))
							) : (
								<div
									style={{
										textAlign: "center",
										padding: "20px",
										color: "gray",
										fontStyle: "italic",
										fontSize: "16px",
										height: "100%",
									}}>
									No Lists Found
								</div>
							)}
						</List>
					</Box>
				)}

				{!isMobile && <Divider flexItem orientation="vertical" sx={{ ml: 3, my: 0.5 }} />}

				<Box
					width={isMobile ? "100%" : "80%"}
					height="100%"
					px={2}
					py={2}
					borderRadius={1}
					justifyContent="flex-start"
					style={{ borderColor: "#ddd", height: "100%" }}
					display="flex"
					flexDirection="column">
					<Box
						display="flex"
						justifyContent="space-between"
						mb={2}
						alignItems={isMobile ? "flex-start" : "center"}
						flexDirection={isMobile ? "column" : "row"}
						width={isMobile ? "100%" : "100%"}>
						<Box width="100%">
							<Typography variant="h6">{selectedItem?.label || selectedItem?.name}</Typography>

							<Typography variant="body1" color="textSecondary" sx={{ width: "100%" }}>
								{selectedItem?.description || "No Description Added"}
							</Typography>
							<Typography variant="body1" fontSize={"11px"} color="textSecondary" fontStyle={"italic"} fontWeight={"bold"} sx={{ mt: 0.75, width: "100%" }}>
								{selectedItem?.user_id && `Created By: ${allUsers.find((u) => u.user_id === selectedItem?.user_id)?.user_display_name || "N/A"}`}
							</Typography>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent={isMobile ? "space-between" : "flex-end"}
							alignItems={"center"}
							gap="10px"
							minWidth={"50%"}
							width={isMobile ? "100%" : "auto"}
							sx={{ marginTop: isMobile ? 2 : 0 }}>
							{user?.user_role === "Viewer" && products.length > 0 && (
								<NotifyPurchaser data={products} mode={"my_list_products"} />
							)}
							<StyledToggleButtonGroup
								size="small"
								value={type}
								exclusive
								onChange={handleType}
								aria-label="text alignment">
								<ToggleButton value="card" aria-label="centered">
									<CropPortraitIcon />
								</ToggleButton>
								<Divider flexItem orientation="vertical" sx={{ mx: 0.5, my: 0.5 }} />
								<ToggleButton value="list" aria-label="centered">
									<ListIcon />
								</ToggleButton>
							</StyledToggleButtonGroup>
							<Box maxWidth={"250px"}>

							<ContextFilterAndSort
								value={searchTerm}
								onSearchChange={handleSearchChange}
								placeholder="Search selected"
								options={sortOptionsProducts}
								selectedOption={sortOptionProducts}
								onSortChange={handleSortChangeProducts}
								showSearch={true}
								showSort={true}
							/>
							</Box>
						</Box>
					</Box>

					<Box
						display="flex"
						flexWrap="wrap"
						justifyContent={isMobile ? "center" : "flex-start"}
						paddingX="15px"
						gap="10px"
						sx={{ overflowY: "auto", maxHeight: "500px", height: "100%" }}>
						{products.filter((product) =>
							product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
						).length === 0 ? (
							<Box
								display="flex"
								justifyContent="center"
								alignContent="center"
								flexDirection={"column"}
								width="100%"
								alignItems="center"
								rowGap={2}
								height="400px">
								<Alert severity="info">No Parts Found</Alert>
								{selectedItem &&
									(selectedItem.user_id === user.user_id || user.user_role === "Admin") && (
										<Button variant="contained" onClick={handleAddProductsNaviagte}>
											Add Parts
										</Button>
									)}
							</Box>
						) : type === "card" ? (
							products
								.filter((product) =>
									product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
								)
								.map((product) => (
									<Box key={product.product_id} marginY="10px">
										<ProductCard
											product={product}
											machineID={product.machine_id}
											onSaveForLater={onSaveForLater}
											onDelete={handleRemoveProduct}
											showSavedForLaterDial={
												selectedItem.user_id === user.user_id || user.user_role === "Admin"
													? false
													: true
											}
											showDial={
												selectedItem.user_id === user.user_id || user.user_role === "Admin"
													? true
													: false
											}
										/>
									</Box>
								))
						) : (
							<ProductList
								style={{
									width: "100%",
									overflowY: "auto",
									maxHeight: "500px",
								}}
								products={products.filter((product) =>
									product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
								)}
								onRemoveProduct={handleRemoveProduct}
								showDelete={
									selectedItem.user_id === user.user_id || user.user_role === "Admin" ? true : false
								}
							/>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
}

export default Recommendations;
